// extracted by mini-css-extract-plugin
export default {"studyList":"StudiesList_studyList__NzDj2"};